<template>
    <div class="row font-20 font-medium justify-center mb-3">
        Thông tin cấp thẻ cho nhân viên
    </div>

    <div class="row">
        <div class="xs5">
            <DxValidationGroup ref="formValidation">
                <div class="row mt-4">
                    <div class="xs12">
                        <DxSelectBox
                            label="Tên nhân viên (*)"
                            v-model="ThongTinCapThe.IdNhanVien"
                            :dataSource="{
                                store: DanhSachNhanVien,
                                pageSize: 20,
                                paginate: true,
                            }"
                            display-expr="HoTen"
                            value-expr="IdNhanVien"
                            :search-enabled="true"
                            styling-mode="outlined"
                            no-data-text="Không có dữ liệu!"
                        >
                            <DxValidator>
                                <DxRequiredRule message="Không được bỏ trống!" />
                            </DxValidator>
                        </DxSelectBox>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="xs12">
                        <DxSelectBox
                            label="Ký hiệu thẻ (*)"
                            v-model="ThongTinCapThe.IdThe"
                            :dataSource="{
                                store: DanhSachTheKiemSoat,
                                pageSize: 20,
                                paginate: true,
                            }"
                            display-expr="KyHieuThe"
                            value-expr="IdThe"
                            :search-enabled="true"
                            styling-mode="outlined"
                            no-data-text="Không có dữ liệu!"
                        >
                            <DxValidator>
                                <DxRequiredRule message="Không được bỏ trống!" />
                            </DxValidator>
                        </DxSelectBox>
                    </div>
                </div>
            </DxValidationGroup>
        </div>
        <div class="xs7 ml-3">
            <div class="row font-16 font-medium mb-1">
                Chọn cổng kiểm soát để cấp thẻ cho nhân viên
            </div>
            <DxValidationGroup ref="formValidationTable">
                <DxDataGrid
                    ref="DanhSachCongKiemSoat"
                    class="table-page"
                    :show-borders="true"
                    :data-source="DanhSachCongKiemSoat"
                    :remote-operations="false"
                    :allow-column-resizing="true"
                    :show-row-lines="true"
                    :column-auto-width="true"
                    :loadPanel="{ showIndicator: false, showPane: false, text: '' }"
                    height="488px"
                    no-data-text="Không có dữ liệu!"
                    :onSelectionChanged="onSelectionChanged"
                >
                    <DxPaging :page-size="20" />
                    <DxScrolling mode="virtual" row-rendering-mode="virtual" />
                    <!-- <DxColumnFixing :enabled="true" /> -->
                    <DxHeaderFilter :visible="true" />
                    <DxFilterRow :visible="true" apply-filter="auto" />
                    <DxSelection
                        select-all-mode="allPages"
                        show-check-boxes-mode="always"
                        mode="multiple"
                    />
                    <DxColumn dataField="IdCongKiemSoat" caption="Cổng kiểm soát" />
                    <DxSummary>
                        <DxTotalItem
                            column="IdCongKiemSoat"
                            summary-type="count"
                            display-format="Tổng: {0}"
                            :show-in-group-footer="true"
                            :align-by-column="true"
                        />
                    </DxSummary>
                </DxDataGrid>
            </DxValidationGroup>
        </div>
    </div>

    <div class="row justify-space-between mt-4">
        <DxButton
            type="danger"
            text="Đóng"
            styling-mode="text"
            width="96px"
            @click="Dong"
        />
        <DxButton
            key="mdi-XACNHAN"
            type="default"
            text="Cấp thẻ"
            styling-mode="contained"
            @click="CapThe()"
        />
    </div>

    <DxPopup
        v-if="ifPopupThongBao"
        v-model:visible="PopupThongBao"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        :width="488"
        height="auto"
        maxHeight="calc(100vh - 96px)"
        @hidden="onHidden('PopupThongBao')"
        :onShown="onShown"
    >
        <DxScrollView ref="DxScrollViewThongBao" width="100%" height="100%">
            <NotificationVue :Params="ParamsThongBao" @click="XacNhanThongBao" />
        </DxScrollView>
    </DxPopup>
</template>
<script>
import {
    DxTextBox,
    DxSelectBox,
    DxValidationGroup,
    DxButton,
    DxValidator,
    DxPopup,
    DxScrollView,
} from "devextreme-vue";
import {
    DxDataGrid,
    DxPaging,
    DxScrolling,
    DxColumnFixing,
    DxHeaderFilter,
    DxFilterRow,
    DxSelection,
    DxColumn,
} from "devextreme-vue/data-grid";
import {
    DxRequiredRule,
    DxRangeRule,
    DxStringLengthRule,
    DxNumericRule,
} from "devextreme-vue/validator";
import NotificationVue from "@sonphat/common-v1/components/Notification.vue";
export default {
    components: {
        DxDataGrid,
        DxPaging,
        DxScrolling,
        DxColumnFixing,
        DxHeaderFilter,
        DxFilterRow,
        DxSelection,
        DxColumn,
        DxSelectBox,
        DxTextBox,
        DxValidationGroup,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxRangeRule,
        DxStringLengthRule,
        DxNumericRule,
        DxPopup,
        DxScrollView,
        NotificationVue,
    },
    data() {
        return {
            DanhSachNhanVien: [],
            DanhSachTheKiemSoat: [],
            ParamsThongBao: {
                state: "Warning",
                button_save: "Đồng ý",
                button_cancel: "Hủy",
                title: "Cảnh báo!",
                message_title: "Bạn muốn thoát khỏi hệ thống?",
                statusCode: 0,
                KeyThongBao: null,
            },
            ifPopupThongBao: false,
            PopupThongBao: false,
        };
    },
    computed: {
        ThongTinCapThe: {
            get() {
                return this.$store.state.CapThe.ThongTinCapThe;
            },
            set(data) {
                this.$store.commit("CapThe/Set", {
                    key: "ThongTinCapThe",
                    data: data,
                });
            },
        },
        DanhSachCongKiemSoat() {
            return this.$store.state.CapThe.DanhSachCongKiemSoat;
        },
    },
    methods: {
        onHidden(name) {
            this["if" + name] = false;
        },
        showPopup(name) {
            this["if" + name] = true;
            this[name] = true;
        },
        Dong() {
            this.$emit("hiddenPopup", "PopupCapTheChoNhanVien");
        },
        onSelectionChanged(e) {
            let selectedRowsData = e.selectedRowsData || [];
            let danhSachCong = selectedRowsData.map((item) => item.IdCongKiemSoat);
            this.ThongTinCapThe.DanhSachCong = this.$Helper.Common.CloneData(
                danhSachCong
            );
        },
        async CapThe() {
            let validate = this.$refs.formValidation.instance.validate();
            if (!validate.isValid) {
                return this.$Helper.Common.autoFocusError(validate);
            }
            let checkCapThe = await this.KiemTraCapThe();
            if (!checkCapThe) {
                return;
            }
            this.ThucHienCapThe();
        },
        async KiemTraCapThe() {
            try {
                this.$startLoading;
                let rsNhanVien = await this.$store.dispatch(
                    "CapThe/KiemTraCapTheChoNhanVien",
                    { IsKiemTraNhanVien: true }
                );

                let rsThe = await this.$store.dispatch(
                    "CapThe/KiemTraCapTheChoNhanVien",
                    { IsKiemTraThe: true }
                );

                if (!rsNhanVien.status) {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Kiểm tra thông tin cấp thẻ thất bại!",
                        message: rsNhanVien.message,
                    });
                    return false;
                }
                if (!rsThe.status) {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Kiểm tra thông tin cấp thẻ thất bại!",
                        message: rsThe.message,
                    });
                    return false;
                }

                let checkNhanVien =
                    rsNhanVien.data &&
                    rsNhanVien.data?.IdThe != this.ThongTinCapThe.IdThe;
                let checkThe =
                    rsThe.data &&
                    rsThe.data?.IdNhanVien != this.ThongTinCapThe.IdNhanVien;

                if (checkNhanVien && checkThe) {
                    this.ParamsThongBao.message_title = `Vui lòng kiểm tra lại thông tin cấp thẻ!`;
                    this.ParamsThongBao.message = `\n- Nhân viên này đã được cấp thẻ: "${rsNhanVien.data?.KyHieuThe}"!\n`;
                    this.ParamsThongBao.message += `- Thẻ kiểm soát này đã được cấp cho nhân viên: "${rsThe.data?.TenNhanVien}"!\n`;
                    this.ParamsThongBao.message += `\n- Bạn có chắc chắn muốn tiếp tục cấp thẻ mới không?`;
                    this.showPopup("PopupThongBao");
                    return false;
                } else if (checkNhanVien) {
                    this.ParamsThongBao.message_title = `Vui lòng kiểm tra lại thông tin cấp thẻ!`;
                    this.ParamsThongBao.message = `\n- Nhân viên này đã được cấp thẻ: "${rsNhanVien.data?.KyHieuThe}"!\n`;
                    this.ParamsThongBao.message += `\n- Bạn có chắc chắn muốn tiếp tục cấp thẻ mới không?`;
                    this.showPopup("PopupThongBao");
                    return false;
                } else if (checkThe) {
                    this.ParamsThongBao.message_title = `Vui lòng kiểm tra lại thông tin cấp thẻ!`;
                    this.ParamsThongBao.message = `\n- Thẻ kiểm soát này đã được cấp cho nhân viên: "${rsThe.data?.TenNhanVien}"!\n`;
                    this.ParamsThongBao.message += `\n- Bạn có chắc chắn muốn tiếp tục cấp thẻ mới không?`;
                    this.showPopup("PopupThongBao");
                    return false;
                }
                return true;
            } catch (error) {
                console.log("🚀 ~ error:", error);
            } finally {
                this.$stopLoading;
            }
        },
        XacNhanThongBao(bool) {
            if (bool == false) {
                this.PopupThongBao = false;
            }
            if (bool == true) {
                this.PopupThongBao = false;
                this.ThucHienCapThe();
            }
        },
        async ThucHienCapThe() {
            try {
                this.$startLoading;
                let rs;
                rs = await this.$store.dispatch("CapThe/CapTheChoNhanVien");
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Cấp thẻ cho nhân viên thành công!"
                    );
                    this.Dong();
                    this.$emit("getData");
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Cấp thẻ cho nhân viên thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                console.log("🚀 ~ error:", error);
                this.$Helper.ThongBaoPopup({
                    message_title: "Cấp thẻ cho nhân viên thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            } finally {
                this.$stopLoading;
            }
        },
        async LayDanhSachNhanVien() {
            try {
                this.DanhSachNhanVien = (
                    await this.$store.dispatch("NhanVien/LayDanhSachNhanVien")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
        async LayDanhSachTheKiemSoat() {
            try {
                this.DanhSachTheKiemSoat = (
                    await this.$store.dispatch("TheKiemSoat/LayDanhSachTheKiemSoat")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
        async LayDanhSachCongKiemSoat() {
            try {
                this.$startLoading;
                this.DanhSachCongKiemSoat = await this.$store.dispatch(
                    "CapThe/LayDanhSachCongKiemSoat"
                );
            } catch (error) {
                console.log("🚀 ~ error", error);
            } finally {
                this.$stopLoading;
            }
        },
    },
    created() {
        this.LayDanhSachNhanVien();
        this.LayDanhSachTheKiemSoat();
        this.LayDanhSachCongKiemSoat();
    },
    mounted() {},
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
